var map = {
	"./1.png": "ae8e",
	"./10.png": "c724",
	"./2.png": "17ba",
	"./3.png": "7ab2",
	"./4.png": "ee06",
	"./5.png": "1cc1",
	"./6.png": "7110",
	"./7.png": "6f39",
	"./8.png": "350e",
	"./9.png": "cf3f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6cd3";